<template>
  <b-modal
    :id="id"
    centered
    hide-header
    hide-footer
    no-enforce-focus
    no-close-on-backdrop
    @show="reset"
  >
    <b-form
      @submit.prevent="onSubmit"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem
      "
    >
      <h2 class="mt-3">加入推廣日期資訊</h2>
      <ValidationObserver ref="form" class="w-100">
        <div class="datetime-picker my-2">
          <AGCLabel required>開始日期</AGCLabel>
          <AGCDateTimePicker
            v-model="publishStartInput"
            name="開始日期"
            rules="required"
          ></AGCDateTimePicker>
        </div>
        <div class="datetime-picker my-2">
          <AGCLabel>結束日期</AGCLabel>
          <AGCDateTimePicker
            v-model="publishEndInput"
            name="結束日期"
            :rules="{ dateAfter: [publishStartInput, false] }"
          ></AGCDateTimePicker>
        </div>
      </ValidationObserver>
      <div
        style="
          width: 100%;
          display: flex;
          gap: 1.5rem;
        "
        class="my-2"
      >
        <b-button @click="$bvModal.hide(id)" variant="outline-primary" style="flex: 1">
          取消
        </b-button>
        <b-button type="submit" variant="primary" style="flex: 1">
          確認
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import AGCDateTimePicker from '@/components/form/AGCDateTimePicker.vue';
import AGCLabel from '@/components/form/AGCLabel.vue';
import formMixin from '@/mixins/form';
import { BButton, BForm } from 'bootstrap-vue';

export default {
  mixins: [formMixin],
  components: {
    AGCDateTimePicker,
    AGCLabel,
    BButton,
    BForm,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    htmlCallback: {
      type: Function,
    },
  },
  data: () => ({
    publishStartInput: '',
    publishEndInput: '',
  }),
  computed: {
    generatedHTML() {
      return `<p></p>
        <p
          style="
            padding-top: 20px;
            padding-bottom: 20px;
            border-width: 1px 0;
            border-style: solid;
            border-color: #e8e8ea;
            line-height: 1.5;
            font-size: 1.1rem;
            font-weight: 400;
            color: #3a177a !important;
          "
        >
          推廣日期：${this.formatDate(this.publishStartInput)}${
  this.publishEndInput ? ` 至 ${this.formatDate(this.publishEndInput)}` : '起'
}
        </p>
        <p></p>`;
    },
  },
  methods: {
    reset() {
      this.publishStartInput = '';
      this.publishEndInput = '';
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const yyyy = date.getFullYear();
      const M = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date
        .getDate()
        .toString()
        .padStart(2, '0');
      return `${yyyy} 年 ${M} 月 ${d} 日`;
    },
    async onSubmit() {
      if ((await this.validate().toPromise()) === undefined) {
        return;
      }
      this.htmlCallback(this.generatedHTML);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  // workaround to make AGCDateTimePicker full width
  .datetime-picker > div > div > div > div:first-of-type {
    flex: 1;

    label,
    label > div {
      width: 100%;

      div > input {
        width: 100% !important;
      }
    }
  }
}
</style>
